<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <path
      style="opacity:0.5; fill:#231f20; stroke:#231f20; stroke-miterlimit:10; stroke-width:2px;"
      d="M32.39,60.64c5.37-6.88,20.25-25.41,20.25-38.84,0-11.18-9.07-20.25-20.25-20.25S12.14,10.62,12.14,21.81c0,13.43,14.88,32.28,20.25,38.84Z"
    />
    <path
      style="stroke:#fff; stroke-miterlimit:10; stroke-width:2px;"
      d="M32.39,62.48c5.37-6.88,20.25-25.41,20.25-38.84,0-11.18-9.07-20.25-20.25-20.25S12.14,12.46,12.14,23.64c0,13.43,14.88,32.28,20.25,38.84Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'BalloonFlatIcon',
};
</script>
